import CashAccountVaultDetailsBase from './base/CashAccountVaultDetailsBase';

export const VaultStatusEnum = {
	Idle: 'Idle',
	Processing: 'Processing',
}

/**
 * @class CashAccountVaultDetails
 * @extends CashAccountVaultDetailsBase
 */
class CashAccountVaultDetails extends CashAccountVaultDetailsBase {
  /**
   * @returns {'Idle' | 'Processing' | ''}
   */
  get status() {
    if (!this.latestCashProcessingBatch || this.latestCashProcessingBatch.dateEnded) {
      return VaultStatusEnum.Idle
    } else if (this.latestCashProcessingBatch && !this.latestCashProcessingBatch.dateEnded) {
      return VaultStatusEnum.Processing
    } else {
      return ''
    }
  }
}

export default CashAccountVaultDetails;
